import { GenIcon } from '../helpers/IconBase.es.js';

const TwoLinesTrashbinDeleteOutlined = (props) => {
  return GenIcon({
    tag: "svg",
    attr: {
      version: "1.0",
      viewBox: "0 0 107.000000 108.000000",
      preserveAspectRatio: "xMidYMid meet"
    },
    child: [
      {
        tag: "g",
        attr: {
          transform: "translate(0.000000,108.000000) scale(0.100000,-0.100000)",
          fill: "#000000",
          stroke: "none"
        },
        child: [
          {
            tag: "path",
            attr: {
              d: "M320 940 c-15 -15 -20 -33 -20 -75 l0 -55 -73 0 c-78 0 -97 -9 -97\n-47 0 -19 5 -23 29 -23 17 0 32 -4 36 -9 3 -5 12 -137 20 -293 13 -270 15\n-284 35 -300 20 -16 49 -18 280 -18 237 0 260 1 281 19 23 18 24 26 35 262 7\n134 13 265 13 292 1 47 1 47 36 47 32 0 35 3 35 29 0 36 -13 41 -101 41 l-69\n0 0 59 c0 90 -3 91 -232 91 -175 0 -189 -1 -208 -20z m370 -90 l0 -40 -160 0\n-160 0 0 40 0 40 160 0 160 0 0 -40z m94 -118 c5 -9 -11 -429 -20 -499 l-5\n-43 -230 0 c-176 0 -229 3 -230 13 0 6 -6 127 -13 267 -7 140 -11 258 -9 263\n6 10 501 9 507 -1z"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M400 495 c0 -168 1 -175 20 -175 19 0 20 7 20 175 0 168 -1 175 -20\n175 -19 0 -20 -7 -20 -175z"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M620 495 c0 -168 1 -175 20 -175 19 0 20 7 20 175 0 168 -1 175 -20\n175 -19 0 -20 -7 -20 -175z"
            }
          }
        ]
      }
    ]
  })(props);
};

export { TwoLinesTrashbinDeleteOutlined };
